/* Ring Premier — move the KeyIdeas step bar under the page header.
   Uses a MutationObserver so the move happens the instant the app inserts the bar. */
(function () {
  if (/(^|[?&])review=1/.test(window.location.search)) document.documentElement.classList.add('rpd-review'), document.addEventListener('DOMContentLoaded',function(){document.body.classList.add('rpd-review');});
  var SEL = '.key-container.page-width-key, .steper-key, .key-ideas-app';
  function place(bar) {
    if (!bar || bar.classList.contains('rpd-steps')) return true;
    var slot = document.querySelector('[data-steps-slot]');
    var target = document.querySelector('.rpd-ch') || document.querySelector('.rpd-p .rpd-p__crumb');
    if (!slot && !target) return false;
    if (slot) { slot.appendChild(bar); slot.classList.add('is-filled'); }
    else if (target.classList.contains('rpd-ch')) target.insertAdjacentElement('afterend', bar);
    else target.insertAdjacentElement('beforebegin', bar);
    bar.classList.add('rpd-steps');
    /* keep any summary/dropdown panels the app absolutely positions inside the bar in normal flow */
    var fix=function(){ Array.prototype.forEach.call(bar.querySelectorAll('*'), function(el){ var cs=getComputedStyle(el); if((cs.position==='absolute'||cs.position==='fixed') && el.offsetHeight>60){ el.style.position='static'; el.style.transform='none'; el.style.margin='14px auto 0'; el.style.maxWidth='1360px'; } }); };
    fix(); new MutationObserver(fix).observe(bar,{childList:true,subtree:true,attributes:true});
    return true;
  }
  var existing = document.querySelector(SEL);
  if (existing && place(existing)) return;
  var obs = new MutationObserver(function () {
    var bar = document.querySelector(SEL);
    if (bar && place(bar)) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); var b = document.querySelector(SEL); if (b) b.classList.add('rpd-steps'); var s = document.querySelector('[data-steps-slot]'); if (s && s.getBoundingClientRect().height < 60 && !(s.firstElementChild && s.firstElementChild.getBoundingClientRect().height > 60)) s.classList.add('is-empty'); }, 8000);
})();
